/* eslint-disable default-param-last */
const SET_FILTERS = "spirit/utils/SET_FILTERS";
const SET_CLEAR_FILTERS = "spirit/utils/SET_CLEAR_FILTERS";
const SET_LIST_SIMULATOR_CAMPUS = "spirit/utils/SET_LIST_SIMULATOR_CAMPUS";

export const initialState = {
  getFiltersCaption: [],
  getFiltersRetention: [],
  listSimulatorCampus: [],
};

// Reducers
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTERS:
      return action.info;
    case SET_CLEAR_FILTERS:
      return initialState;
    case SET_LIST_SIMULATOR_CAMPUS:
      return {
        ...state,
        listSimulatorCampus: action.info,
      };
    default:
      return state;
  }
};

// Action Creators
export const setFilters = (info) => ({
  type: SET_FILTERS,
  info,
});

export const setClearFilters = (info) => ({
  type: SET_CLEAR_FILTERS,
  info,
});

export const setListSimulatorCampus = (info) => ({
  type: SET_LIST_SIMULATOR_CAMPUS,
  info,
});
